import { createBackgroundColorFunctions as c } from "./index.es362.js";
import { createExternalTooltipHandler as u } from "./index.es363.js";
const x = '"ars_maquette_web_one", Arial, sans-serif;', g = (t, n) => {
  const i = t.split(/\s+/);
  if (!i.length)
    return [];
  const a = [i.shift() || ""];
  for (const e of i) {
    const l = a[a.length - 1];
    e.length + 1 + l.length <= n ? a[a.length - 1] = `${l} ${e} ` : a.push(e);
  }
  return a;
}, p = (t, n) => {
  const i = t.unitsName ? ` ${t.unitsName}` : t.currentUnits === "Percent" ? "%" : t.currentUnits === "Per 1000" ? " pr. 1000" : "", a = u(n), e = t.legendElementId ? {
    legend: { display: !1 },
    htmlLegend: { containerID: t.legendElementId }
  } : {
    legend: {
      display: !0,
      position: "bottom",
      align: "start",
      textAlign: "left",
      labels: {
        boxWidth: 25,
        boxHeight: 25,
        textAlign: "left",
        align: "left",
        padding: 10
      },
      title: {
        display: !!t.legendTitle,
        font: {
          size: 16,
          family: x
        },
        text: t.legendTitle
      }
    }
  }, l = t.annotations && t.annotations.length ? {
    annotation: {
      annotations: t.annotations.map((r, o) => ({
        type: "line",
        id: `line${o}`,
        xMin: r.value,
        xMax: r.value,
        label: {
          rotation: 90,
          content: r.text,
          display: !0,
          color: "#000",
          position: "end",
          xAdjust: 14,
          backgroundColor: "transparent",
          font: {
            weight: "normal"
          }
        },
        borderColor: "#000",
        borderWidth: 2
      })).reduce((r, o) => ({ ...r, [o.id]: o }), {})
    }
  } : {};
  return {
    chartJsBackgroundColorPlugin: {
      backgroundColor: t.chartBackgroundColor || "transparent",
      chartAreaBackgroundColor: t.chartAreaBackgroundColor || "#fff"
    },
    yScaleTitlePlugin: {
      title: t.yTitle || "",
      enabled: !!t.yTitle
    },
    title: {
      display: !!t.title,
      text: t.title
    },
    ...e,
    ...l,
    tooltip: {
      enabled: !1,
      external: a,
      position: "nearest",
      callbacks: {
        label: function(r) {
          let o = r.dataset.label || "";
          o && (o += ": ");
          const s = t.indexAxis === "y" ? "x" : "y";
          if (r.parsed[s] !== null) {
            const d = Intl.NumberFormat("no-nb");
            o += `${d.format(
              r.parsed[s]
            )}${i}`;
          }
          return o;
        }
      }
    }
  };
}, y = (t) => {
  const n = {};
  if (t.xTicksMax) {
    const l = t.xTicksMax;
    n.maxRotation = 0, n.autoSkip = !1, n.callback = function(r) {
      const o = this.getLabelForValue(r);
      return typeof o == "string" && o.length > l ? g(o, l) : o;
    };
  }
  const i = t.isStacked ? { stacked: !0 } : {}, a = { ...n, autoSkip: !0, maxRotation: 45 }, e = {
    ...n,
    crossAlign: "far"
  };
  return {
    x: {
      ...i,
      ticks: a,
      ..."yMax" in t && t.indexAxis === "y" ? { suggestedMax: t.yMax } : {},
      font: {
        size: 16
      },
      title: {
        display: !!t.xTitle,
        text: t.xTitle || ""
      },
      grid: {
        offset: !0
      },
      border: {
        width: t.xBorderWidth || 0,
        color: t.xBorderColor || "transparent"
      },
      ...t.isStacked && "yMax" in t && t.indexAxis === "y" ? { max: t.yMax } : {}
    },
    y: {
      ...i,
      ticks: e,
      ...typeof t.suggestedMin == "number" ? { suggestedMin: t.suggestedMin } : {},
      ..."yMax" in t && t.indexAxis !== "y" ? { suggestedMax: t.yMax } : {},
      display: !0,
      border: {
        width: t.yBorderWidth || 0,
        color: t.yBorderColor || "transparent"
      },
      font: {
        size: 16
      },
      ...t.isStacked && "yMax" in t && t.indexAxis !== "y" ? { max: t.yMax } : {},
      title: {
        display: !1,
        text: t.yTitle || ""
      }
    }
  };
}, f = (t, n, i) => ({
  bar: {
    backgroundColor: n
  },
  line: {
    backgroundColor: n,
    borderColor: i,
    tension: "lineTension" in t ? t.lineTension : 0
  },
  point: {
    radius: "pointRadius" in t ? t.pointRadius : 5,
    hoverRadius: "pointHoverRadius" in t ? t.pointHoverRadius : 8,
    backgroundColor: i
  }
}), m = (t) => {
  const { background: n, colorString: i, border: a } = c(
    t.backgroundColorInit
  ), e = {
    maintainAspectRatio: !0,
    aspectRatio: 1.1
  };
  return {
    locale: "nb-NO",
    maintainAspectRatio: !1,
    ...t.indexAxis === "y" ? e : {},
    responsive: !0,
    plugins: p(t, i),
    scales: y(t),
    elements: f(t, n, a),
    indexAxis: t.indexAxis,
    layout: {
      padding: {
        top: 40,
        bottom: 0
      }
    }
  };
};
export {
  m as createChartOptions,
  g as splitToMaxLength
};
//# sourceMappingURL=index.es275.js.map
